module.exports = __webpack_public_path__ + "img/tresspass.4c44fe0e.png";